import { useMemo } from 'react';
import FuzzySearch from 'fuzzy-search';
import { APITypes } from '../../../../../primary-record-types';
import { OrgOrProfileCareTeamMember } from '../../../../../utils/careTeamUtils';

type ContactDetailsSearchKeys =
    | keyof APITypes.medicalProfileService.SupportCareTeamContactDetails
    | keyof APITypes.medicalProfileService.ProviderCareTeamContactDetails
    | keyof APITypes.medicalProfileService.InsuranceCareTeamContactDetails;

type MetadataSearchKeys =
    | keyof APITypes.medicalProfileService.SupportCareTeamMetadata
    | keyof APITypes.medicalProfileService.ProviderCareTeamMetadata
    | keyof APITypes.medicalProfileService.InsuranceCareTeamMetadata;

const contactDetailsSearchKeys: ContactDetailsSearchKeys[] = [
    'firstName',
    'lastName',
    'description',
    'company',
    'role',
    'email',
    'city',
];

const metadataSearchKeys: MetadataSearchKeys[] = [
    'insuranceProviderName',
    'insuranceRole',
    'providerType',
    'providerSpecialty',
    'primaryCarrierFirstName',
    'primaryCarrierLastName',
];

export function useFilterCareTeamMembers(careTeamMembers: OrgOrProfileCareTeamMember[], filter: string) {
    const filteredCareTeamMembers = useMemo(() => {
        if (!filter) return careTeamMembers;

        const searcher = new FuzzySearch(
            careTeamMembers,
            [
                ...contactDetailsSearchKeys.map((key) => `contactDetails.${key}`),
                ...metadataSearchKeys.map((key) => `metadata.${key}`),
            ],
            {
                caseSensitive: false,
                sort: true,
            },
        );

        return searcher.search(filter);
    }, [careTeamMembers, filter]);

    return filteredCareTeamMembers;
}
